module.exports = __webpack_public_path__ + "static/img/握手.883104e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/握手.png
// module id = 07Ug
// module chunks = 3